import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type MessageFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const MessageFilled = forwardRef<SVGSVGElement, MessageFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-5.25 -5.25) scale(0.71875)">
        <path opacity="0.01" d="M8 8H40V40H8V8Z" />
        <path d="M11.2 12.2669C11.2 11.6778 11.6775 11.2002 12.2667 11.2002H35.7333C36.3224 11.2002 36.8 11.6778 36.8 12.2669V13.3335C36.8 13.9226 36.3224 14.4002 35.7333 14.4002H12.2667C11.6775 14.4002 11.2 13.9226 11.2 13.3335V12.2669ZM37.8666 15.4669C38.1495 15.4669 38.4209 15.5792 38.6209 15.7793C38.8209 15.9793 38.9333 16.2506 38.9333 16.5335V33.6002C38.9333 33.8831 38.8209 34.1544 38.6209 34.3544C38.4209 34.5545 38.1495 34.6669 37.8666 34.6669H28.2666L24.3776 38.5559C24.2775 38.6562 24.1417 38.7126 24 38.7126C23.8583 38.7126 23.7224 38.6562 23.6224 38.5559L19.7333 34.6669H10.1333C9.85042 34.6669 9.57911 34.5545 9.37907 34.3544C9.17903 34.1544 9.06665 33.8831 9.06665 33.6002V16.5335C9.06665 16.2506 9.17903 15.9793 9.37907 15.7793C9.57911 15.5792 9.85042 15.4669 10.1333 15.4669H37.8666ZM15.4667 22.9335C14.2885 22.9337 13.3336 23.8888 13.3336 25.0669C13.3336 26.245 14.2885 27.2001 15.4667 27.2002C16.2289 27.2003 16.9332 26.7937 17.3144 26.1336C17.6955 25.4735 17.6955 24.6602 17.3144 24.0001C16.9332 23.34 16.2289 22.9334 15.4667 22.9335ZM24 22.9335C22.8219 22.9337 21.8669 23.8888 21.8669 25.0669C21.8669 26.245 22.8219 27.2001 24 27.2002C24.7622 27.2003 25.4666 26.7937 25.8477 26.1336C26.2289 25.4735 26.2289 24.6602 25.8477 24.0001C25.4666 23.34 24.7622 22.9334 24 22.9335ZM32.5333 22.9335C31.3552 22.9337 30.4002 23.8888 30.4002 25.0669C30.4002 26.245 31.3552 27.2001 32.5333 27.2002C33.2955 27.2003 33.9999 26.7937 34.3811 26.1336C34.7622 25.4735 34.7622 24.6602 34.3811 24.0001C33.9999 23.34 33.2955 22.9334 32.5333 22.9335Z" />
      </g>
    </svg>
  ),
);

MessageFilled.displayName = 'MessageFilled';

export default MessageFilled;
